import React from 'react'
import { Icons } from '../../assets'
import Button from '../Button'
import SearchInput from '../SearchInput'
import SortingDropdown from '../SortingDropdown'
import classes from "./style.module.scss";


const Header = ({ isHeader, header, isSearchInput, isFilter, isButton, text, placeholder, onChange,isSorting, onClick }) => {
    return (
        <div className=' flex justify-between align-middle'>
            {isHeader ? <p className={`${classes.header}`}>{header}</p> : ""}
            <div className='flex justify-between align-middle gap-4'>
                {isSearchInput ? <SearchInput placeholder={placeholder} onChange={onChange} width={"336px"} /> : ""}
                {isFilter ? <img src={Icons.filterIcon} className={`${classes.filter}`} /> : ""}
                {isSorting ? <SortingDropdown/> : ""}
                {isButton ? <Button text={text} onClick={onClick} /> : ""}
            </div>
        </div>
    )
}

export default Header